import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AdminProtal() {
  const { t } = useTranslation();

  const adminSections = [
    {
      title: t("Inbox Follow-up"),
      description: t("Manage and respond to incoming messages and inquiries"),
      path: "/ma/admin/view/inbox",
    },
    {
      title: t("Employees"),
      description: t("View and manage employee profiles and records"),
      path: "/ma/admin/view/employees",
    },
    {
      title: t("Job Applications"),
      description: t("Review and process job applications"),
      path: "/ma/admin/view/job",
    },
    {
      title: t("Email Subscribe"),
      description: t("Review and process Subscribtion"),
      path: "/ma/admin/view/subscribe",
    },
  ];

  return (
    <section className="min-h-screen bg-gray-100 flex items-center justify-center py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#3896BE] mb-8">
          {t("Admin Portal")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {adminSections.map((section, index) => (
            <Link
              key={index}
              to={section.path}
              onClick={section.onClick}
              className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center border border-[#3896BE]/20 hover:border-[#3896BE] focus:outline-none"
            >
              <div className="text-xl font-semibold text-[#3896BE] mb-3">
                {section.title}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                {section.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
